<ng-container *ngIf="printLabelData$ | async as data">
  <section class="label-section">
    <app-print-label-list
      [printLabelData]="data"
      [productionOrderId]="productionOrderId$ | async"
    ></app-print-label-list>

    <!-- WIP -->
    <div class="label-section__flex">
      <div class="label-section__title label-section__title--grow">{{ 'LABELS.OUTPUT_WIP' | translate }}</div>
      <app-search-bar
        class="label-section__search"
        (searchBarValueChanged)="searchLabels($event)"
        [searchBarPlaceholder]="'LABELS.SEARCH_BAR_PLACEHOLDER' | translate"
      ></app-search-bar>
    </div>
    <div class="label-section__table">
      <app-material-label-table
        [value]="data.filteredLabels"
        [allItemAction]="outputAllItemAction"
        [perItemAction]="outputPerItemAction"
        [slitCount]="data.slitCount"
      ></app-material-label-table>
    </div>
  </section>

  <ng-template #outputAllItemAction>
    <lib-split-button
      class="table-action"
      appendTo="body"
      [items]="rowListButtonItems(data.labels)"
      [loadingTopic]="MODAL_LOADING_TOPIC"
    ></lib-split-button>
  </ng-template>

  <ng-template #outputPerItemAction let-row>
    <ng-container *ngIf="row.printMode !== PRINT_MODE.None">
      <lib-split-button
        class="table-action"
        appendTo="body"
        [items]="rowButtonItems(row)"
        [loadingTopic]="LOADING_TOPIC + row.containerSequence"
      ></lib-split-button>
    </ng-container>
  </ng-template>
</ng-container>
